/*

This is experimental code for recording ad-tracking events which auto-creates a campaign and associates events with that
campaign. This will not be implemented but we are keeping this code for future reference if we decide to enable this feature.

*/
import lodash from 'lodash'
import appStorage from 'storage/appStorage'

// Module-level singleton for event tracking (shared across all components)
type TrackingEvent = {
  event_type: number
  code: string
  placement: string
  campaign_params?: Record<string, any>
  action_type_code?: string | null
}

const trackingEventsQueue: TrackingEvent[] = []

const sendTrackingEvents = async () => {
  if (trackingEventsQueue.length === 0) return

  const eventsToSend = [...trackingEventsQueue]
  trackingEventsQueue.length = 0 // Clear the queue

  try {
    const response = await fetch(`${window.API_ROOT}/api/ads/event/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + appStorage.getToken(),
      },
      body: JSON.stringify(eventsToSend),
    })
    if (!response.ok) {
      throw new Error('Failed to send events')
    }
  } catch (error) {
    console.error(error)
  }
}

const debouncedSendTrackingEvents = lodash.debounce(sendTrackingEvents, 3000)

export const recordTrackingEvent = (
  eventType: number,
  code: string,
  placement: string,
  action_type_code: string | null = null
) => {
  trackingEventsQueue.push({
    event_type: eventType,
    code,
    placement,
    action_type_code,
    campaign_params: {
      campaign_type: 'component',
      component_code: code,
    },
  })
  debouncedSendTrackingEvents()
}
